import React, { Component } from 'react';
import Grid from '../../../components/Utils/GridVDocumento';
import PropTypes from 'prop-types';
import { Field, reduxForm } from 'redux-form/immutable';
import {
    SelectField
  } from "../../../components/Utils/renderField/renderField";
import moment from 'moment';

class ConfigModulosList extends Component{
    static propTypes = {
        data: PropTypes.object.isRequired,
        loader: PropTypes.bool.isRequired,
        onSortChange: PropTypes.func,
    };

    static defaultProps = {
        loading: false
    };

    componentDidMount = () => {
        const { listarModulos, getModulos } = this.props;
        listarModulos();
        getModulos();
    }
    
    render(){
        const { 
            loader, 
            registroModulo,
            modulo,
            moduloAsig
        } = this.props;
        
        let ruta = window.location.href;
        let id_emp = ruta.split('/');
        
        return(
            <React.Fragment>
                <br />
                <h3 className="p-2 bg-secondary title">Módulos</h3>
                <div className="row mb-2">
                    <div className='col-12'>
                        <div className="form-floating">
                            <Field
                                name="modulo"
                                options={modulo}
                                dato={0}
                                component={SelectField}
                                className="form-select"
                                msj="Seleccionar módulo"
                            />
                        </div>
                    </div>
                </div>    
                <button
                    className='btn mr-2 mb-3 btn-primary'
                    onClick={registroModulo}
                >
                    Guardar
                </button>
                <a
                    href = {`/#/ajustes/${id_emp[5]}`}
                    className='btn btn-secondary mb-3'
                >
                Regresar
                </a>
                {moduloAsig &&
                    <Grid 
                        hover 
                        striped 
                        data={moduloAsig} 
                        loading={loader} 
                        headerStyle={ { background: 'black' } } 
                        //onPageChange={onPageChange}
                        //onSortChange={onSortChange} 
                    >
                        <TableHeaderColumn
                            isKey
                            dataField="modulo"
                            headerAlign="center"
                            width="550"
                            dataSort
                            thStyle={ 
                                {color: 'white'}}
                            tdStyle={
                                {color: 'white'}}
                        >
                            Módulo
                        </TableHeaderColumn>
                        <TableHeaderColumn
                            dataField="fecha_alta"
                            headerAlign="center"
                            dataFormat={(cell, row)=>{
                                return moment(cell).format("DD/MM/YYYY HH:mm:ss");
                            }}
                            dataSort
                            thStyle={ 
                                {color: 'white'}}
                            tdStyle={
                                {color: 'white'}}
                        >
                            Fecha de activación
                        </TableHeaderColumn>
                    </Grid>
                }
            </React.Fragment>
        );
    }
}
export default reduxForm({
    form: 'FormConfigModulos',
})(ConfigModulosList );
